// Till now we are using in head tag of layout file, because "magic" property not defined
import Alpine, { data } from 'alpinejs';
import intersect from '@alpinejs/intersect';
import axios from 'axios';

var properties = [];
var projects = [];


Alpine.data('CreateUACMessage', (params = null) => ({
    show: false,
    isPages: false,
    isLinkDisabled: false,
    openBuyPageFilters: false,
    init() {
        const _this = this;
        this.$nextTick(() => {
            /* Show filters if a value is selected in the page field with the value 'buy-page'.*/
            const isTrue = _this.toggleBuyPageFilters(_this.$refs.messagePageField.value);
            if (isTrue) {
                if (_this.$refs.cityField.value) {
                    _this.selectCity(_this.$refs.cityField.value);
                }
                if (_this.$refs.regionField.value) {
                    _this.selectRegion(_this.$refs.regionField.value);
                }
                if (_this.$refs.projectField.value) {
                    _this.selectProject(_this.$refs.projectField.value);
                }
            }
        });
    },
    changeTopic($event) {
        if ($event.target.value == 'general') {
            this.isPages = true;
            this.isLinkDisabled = true;
            document.getElementById('link').value = '';
        } else {
            this.isPages = false;
            this.isLinkDisabled = false;
        }

        if ($event.target.value == 'update_app') {
            this.isLinkDisabled = true;
        } else {
            this.isLinkDisabled = false;
        }
    },
    changePage($event) {
        this.toggleBuyPageFilters($event.target.value);
    },
    toggleBuyPageFilters(value) {
        return this.openBuyPageFilters = (value == 'buy-page');
    },
    selectCity(value) {
        let hasValue = value != '';
        this.$refs.regionField.disabled = hasValue;
        this.$refs.projectField.disabled = hasValue;
    },
    selectRegion(value) {
        let hasValue = value != '';
        this.$refs.cityField.disabled = hasValue;
        this.$refs.projectField.disabled = hasValue;
    },
    selectProject(value) {
        let hasValue = value != '';
        this.$refs.cityField.disabled = hasValue;
        this.$refs.regionField.disabled = hasValue;
    },
}));
Alpine.data('homePageSlider', (params = null) => ({
    properties: [],
    projects: [],
    sliders: null,
    showLocation: true,
    apiUrl: params.apiUrl,
    slidesPerDisplay: 1,
    slider_type: params.type,
    async init() {
        var _self = this;
        if (params && params.isProject) {
            await _self.getProjects();
        } else {
            await _self.getProperties();
        }
        this.$watch('properties', (newVal, oldVal) => {

            const properties = newVal.map(x => x.id)
            const result = manageBuyPagePropertyIds(properties);
            if (result.Newly_Added_IDs.length > 0) {
                axios.post(`/${window.global.country_code}/track-property-impression`, {
                    'properties': result.Newly_Added_IDs
                }).then((result) => {


                }).catch((err) => {


                });
            }
        })
        this.removeCompareFromBucket()
    },
    removeCompareFromBucket() {
        var _this = this;
        document.addEventListener('DOMContentLoaded', function () {
            window.addEventListener('removeCompareFromBucket', function (event) {
                var id = event.detail.data;
                let index = _this.properties.findIndex(x => x.id == id);
                if (index != -1) {
                    _this.properties[index].is_compare = false;
                }
            });
        });
    },
    initSlider() {
        var _self = this
        this.$nextTick(() => {
            this.sliders = new Swiper(this.$refs.sliders, { // Changed from slider to sliders
                loop: false,
                rewind: false,
                autoplay: false,
                slidesPerView: 1.1,
                spaceBetween: 10,
                breakpoints: {
                    640: {
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                },
                on: {
                    init: function () {
                        _self.slidesPerDisplay = this.params.slidesPerView;

                    },
                    update: function () {
                        _self.slidesPerDisplay = this.params.slidesPerView;
                    },
                    slideChange: function () {
                        // console.log('Active slide index:', this.activeIndex);
                    },
                    reachEnd: function () {
                        // console.log('Reached the last slide');
                    },
                    resize: function () {
                        _self.slidesPerDisplay = this.params.slidesPerView;
                    },
                },
            });
        });
    },
    next() {
        this.sliders.slideNext(); // Changed from slider to sliders
    },
    prev() {
        this.sliders.slidePrev(); // Changed from slider to sliders
    },
    getProperties() {
        axios.get(this.apiUrl, {
            params: {
                'user_id': window.global.user_id
            }
        }).then((result) => {
            this.properties = result.data.properties;
            const ids = this.properties.map(x => x.id)
            this.setPropertyIds(ids);
            this.initSlider(); // Initialize slider after properties are set

            if (this.slider_type == 'developer_properties') {
                Alpine.store('sameAndSimilarPropertiesTabStore').updateSameProperties(ids.length)
            }
            if (this.slider_type == 'similar_properties') {
                Alpine.store('sameAndSimilarPropertiesTabStore').updateSimilarProperties(ids.length)
            }
        }).catch((err) => {
            console.error(err);
        });
    },
    setPropertyIds(ids) {
        properties.push(...ids);
    },
    setProjectIds(ids) {
        projects.push(...ids);
    },
    getProjects() {
        axios.get(this.apiUrl).then((result) => {
            this.projects = result.data.data;
            const ids = this.projects.map(x => x.id)
            this.setProjectIds(ids);
            triggerTrackImpression();
            this.initSlider(); // Initialize slider after properties are set
            if (this.slider_type == 'developer_properties') {
                Alpine.store('sameAndSimilarPropertiesTabStore').updateSameProperties(ids.length)
            }
            if (this.slider_type == 'similar_properties') {
                Alpine.store('sameAndSimilarPropertiesTabStore').updateSimilarProperties(ids.length)
            }
        }).catch((err) => {
            console.error(err);
        });
    },
    limitLetters(text, limit) {
        if (!text) return text;
        return text.length > limit ? text.substring(0, limit) + "..." : text;
    },
    async addToCompareArray($event, property) {
        let id = property?.id;
        if ($event.target.checked) {
            await axios.get(`/${window.global.country_code}/add-to-compare-array/${id}`).then((res) => {
                Livewire.emitTo('manage-compare', '$refresh');
                Livewire.emitTo('count-compared-properties', '$refresh');
                setTimeout(async () => {
                    await this.handleAnimation($event.target, property);
                    await this.clickProperty(id);
                }, 0);
            }).catch(err => {
                console.log(err.response);
            });
        } else {
            axios.get(`/${window.global.country_code}/remove-from-compare-array/${id}`, {
                params: {
                    user_id: window.global.user_id
                }
            }).then((res) => {
                Livewire.emitTo('manage-compare', '$refresh');
                Livewire.emitTo('count-compared-properties', '$refresh');
            }).catch(err => {
                console.log(err.response);
            });
        }
    },
    unLikeProperty(id) {
        axios.delete(window.global.base_url + '/' + window.global.country_code + '/unlike-property-map', {
            params: {
                'user_id': window.global.user_id,
                'property_id': id
            }
        }).then(response => {
            body.classList.remove('modal-open');
            let index = this.properties.findIndex(x => x.id == response.data.data.property_id);
            this.properties[index].is_liked = false;
            // this.alert('success', response.data.message);
        }).catch(error => {
            body.classList.remove('modal-open');
        });
    },
    handleAnimation(btn, property) {
        $('.compare-counter').addClass('animate-bounce');
        $('.compare-counter').addClass('duration-3000');
        setTimeout(() => {
            $('.compare-counter').removeClass('animate-bounce');
            $('.compare-counter').removeClass('duration-3000');
        }, 2000);
    },
    makePhoneCall(number) {
        // window.open('tel:' + number,false);
        window.location.href = 'tel:' + number;

    },
    openCallModal(property) {
        // this.email_property = property;
        // if (window.isMobileScreen) {
        //     this.makePhoneCall(property?.mobile_number);
        // }
        Livewire.emit('openCallPopup', {
            id: property?.id,
            type: 'property',
            image: property?.images[0],
        });
        // this.open_call_modal = true;
        // body.classList.add('modal-open');
    },
    closeCallModal() {
        this.open_call_modal = false;
        body.classList.remove('modal-open');
        setTimeout(() => {
            this.email_property = null;
        }, 500);
    },
    openEmailModal(property) {
        Livewire.emit('openEmailPopup', {
            'id': property?.id,
            'image': property?.images[0],
            'developer': property?.developer_id,
            'type': 'property'
        });
    },
    closeEmailModal() {
        this.open = false
        this.email_open = false
        body.classList.remove('modal-open');
    },
    clickProperty(id, link = '') {
        axios.post('api/local/property-click', {
            'property_id': id
        }).then((result) => {

        }).catch((err) => {

        });
        if (link != '') {
            window.open(link, true);
        }
    },
    clickProject(id, devId) {
        axios.post('/api/local/project-click', {
            'project_id': id,
            'developer_id': devId,
        }).then((result) => {

        }).catch((err) => {

        });
    },
    // Like
    openLikePropertyModal(id) {
        if (!window.global.user_id) {
            const login = document.getElementById('login_modal_button').click()
            return;
        }
        Livewire.emit('openLikePopup', id);
        var _this = this
        window.addEventListener('likeResponseReceived', function (event) {
            var responseData = event.detail.data;
            // Use the response data in your JavaScript logic
            let index = _this.properties.findIndex(x => x.id == responseData?.id);
            if (index != -1) {
                _this.properties[index].is_liked = true;
            }
        });
    },
    unLikeProperty(id) {
        axios.delete(window.global.base_url + '/' + window.global.country_code + '/unlike-property-map', {
            params: {
                'user_id': window.global.user_id,
                'property_id': id
            }
        }).then((response) => {
            body.classList.remove('modal-open');
            let index = this.properties.findIndex(x => x.id == response.data.data.property_id);
            this.properties[index].is_liked = false;
            // this.alert('success', response.data.message);
        }).catch((error) => {
            body.classList.remove('modal-open');
        })

    },

}));
if (false) {
    Alpine.data('VideoModal', () => ({
        isOpen: false,
        videoEl: null,
        urlSegment: '',
        init() {
            this.urlSegment = window.location.pathname.split('/').filter((x) => x != '')[1];
            this.urlSegment = this.urlSegment == undefined ? "home-page" : this.urlSegment;
            this.$nextTick(() => {
                if (localStorage.getItem(`close_video_button_${this.urlSegment}`) == null) {
                    setTimeout(() => {
                        this.isOpen = true;
                        var event = new CustomEvent('open-video-modal');
                        window.dispatchEvent(event)
                    }, 5000); // 5 seconds
                }
            })
        },
        closeVideoButton() {
            this.isOpen = false;
            localStorage.setItem(`close_video_button_${this.urlSegment}`, true);
        }
    }));
}

Alpine.data('DownloadAppModal', () => ({
    isOpen: false,
    init() {
        this.$nextTick(() => {
            if (localStorage.getItem('close_download_button') == null) {
                setTimeout(() => {
                    var event = new CustomEvent('open-download-app-modal');
                    window.dispatchEvent(event)
                }, 60000); // 60 seconds || 1 minute
            }
        })
    },
    closeDownloadButton() {
        localStorage.setItem('close_download_button', true);
    }
}));

Alpine.data('DownloadAppModalOnMobile', () => ({
    isOpen: false,
    init() {
        this.$nextTick(() => {
            const closedTime = localStorage.getItem('close_mobile_download_button');
            const now = new Date().getTime();
            if (!closedTime || now - closedTime > 24 * 60 * 60 * 1000) { // if user has closed it 24 hours before then show it again
                setTimeout(() => {
                    var event = new CustomEvent('open-download-app-on-mobile-modal');
                    window.dispatchEvent(event);
                }, 30000); // 30 seconds
            }
        })
    },
    closeMobileDownloadButton() {
        const now = new Date().getTime();
        localStorage.setItem('close_mobile_download_button', now);
    }
}));


Alpine.data('CompareBottomToast', () => ({
    visible: false,
    count: 0,
    init() {
        window.addEventListener('get-compare-count', (e) => {
            this.count = e.detail.count;
            this.visible = e.detail.count > 0;
        });

        // Optionally, you can add a watcher to track changes to `count` (if needed)
        this.$watch('count', (newCount) => {
            //console.log(newCount, 'newCount');
        });
    },
    callbackCount(e) {
        this.count = e.detail.count;
        this.visible = e.detail.count > 0;
    },
    toggleFromCompareToast() {
        let event = new CustomEvent('toggle-notification');
        window.dispatchEvent(event);
    }
}));

Alpine.data('signUpComponent', () => ({
    phone: null,
    isValid: false, // to track the validity state
    errorMessage: '', // to display error messages
    fullNumber: '', // to display error messages
    countryFlagCode: '', // to display error messages
    init() {
        this.$nextTick(() => {
            const input = document.querySelector("#telInput");
            var countryCode = window.global.country_code;
            countryCode = (countryCode === '' ? 'us' : countryCode);

            // init plugin
            const iti = window.intlTelInput(input, {
                nationalMode: true,
                initialCountry: "ae",
                preferredCountries: [countryCode],
                separateDialCode: true,
                placeholderNumberType: 'MOBILE',
                utilsScript: "/vendor/intl-tel-input/build/js/utils.js?1684676252775"
            });

            // Watch the input field for changes
            input.addEventListener('input', () => {
                this.countryFlagCode = iti.getSelectedCountryData().dialCode;
                this.validateNumber(iti);
            });
            // Custom validation method to check phone number validity
            $.validator.addMethod("validPhone", (value, element) => {
                return iti.isValidNumber() && this.isValid;  // Checks if the number is valid using intlTelInput plugin
            }, "Please enter a valid phone number.");

            $("#signupForm").validate({
                rules: {
                    first_name: {
                        required: true,
                        minlength: 2,
                        maxlength: 50,
                        validNamePattern: true
                    },
                    last_name: {
                        required: true,
                        minlength: 2,
                        maxlength: 50,
                        validNamePattern: true
                    },
                    email: {
                        required: true,
                        email: true,
                        validEmailPattern: true,
                        remote: {
                            url: "/verify/check-email", // Replace with your server-side validation endpoint
                            type: "post", // The HTTP method to use for the request
                            data: {
                                '_token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                            }
                        }
                    },
                    phone: {
                        required: true,
                        validPhone: true
                    },
                    password: {
                        required: true,
                        minlength: 8,
                        passwordPattern: true
                    },
                    password_confirmation: {
                        required: true,
                        equalTo: "#password"
                    },
                },
                messages: {
                    email: {
                        required: "This email field is required",
                        email: "Please enter a valid email",
                        remote: "Email already exists" // Error message for remote validation failure
                    },
                    password: {
                        required: "Password is required",
                        minlength: "Password cannot be less than 8 characters",
                    },
                    password_confirmation: {
                        required: 'This field is required',
                        equalTo: 'The password confirmation does not match.'
                    }
                },
                errorPlacement: function (error, element) {
                    this.errorMessage = '';
                    this.isValid = true;
                    let password = element.attr('name') == 'password';
                    let password_confirmation = element.attr('name') == 'password_confirmation';
                    let mathcaptcha = element.attr('name') == 'mathcaptcha';
                    let phone = element.attr('name') == 'phone';
                    if (password) {
                        error.appendTo(element.parent().parent().parent().siblings(".error-container-password"));
                    } else if (password_confirmation) {
                        error.appendTo(element.parent().parent().parent().siblings(".error-container-confirm"));
                    } else if (mathcaptcha) {
                        error.appendTo(element.parent().parent().siblings(".error-container-captcha"));
                    } else if (phone) {
                        error.appendTo(element.parent().parent().siblings(".error-container"));
                    } else {
                        error.appendTo(element.parent().siblings(".error-container"));
                    }
                },
                submitHandler: function (form, event) {
                    event.preventDefault();

                    // grecaptcha.ready(function () {
                    //     grecaptcha.execute(window.global.RECAPTCHAV3_SITEKEY, { action: 'submit' }).then(function (token) {
                    //         // Add token to the form
                    //         $('#recaptchaToken').val(token);
                    //         // Submit the form
                    //     });
                    // });

                    form.submit();

                    return false;
                    // form.submit();
                }
            });
        });
    },

    validateNumber(iti) {
        const input = document.querySelector("#telInput");
        if (iti.isValidNumber()) {

            this.fullNumber = iti.getNumber();
            this.isValid = true;
            this.errorMessage = '';
        } else {
            this.fullNumber = '';
            this.isValid = false;
            this.errorMessage = 'Please enter a valid phone number.';
        }
    }
}));

Alpine.data('sliderComponent', (params = null) => ({
    slider_component: null,
    // slidesPerDisplay: 1,
    init() {
        this.initSlider();
    },
    initSlider() {
        var _self = this
        this.$nextTick(() => {
            this.slider_component = new Swiper(this.$refs.slider_component, { // Changed from slider to sliders
                loop: false,
                rewind: true,
                autoplay: false,
                // autoplay: {
                //     delay: 3000, // in milliseconds
                //     disableOnInteraction: true,
                // },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    class: 'text-white'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 1,
                on: {
                    // init: function () {
                    //     _self.slidesPerDisplay = this.params.slidesPerView;
                    // },
                    // update: function () {
                    //     _self.slidesPerDisplay = this.params.slidesPerView;
                    // },
                    // slideChange: function () {
                    //     // console.log('Active slide index:', this.activeIndex);
                    // },
                    // reachEnd: function () {
                    //     // console.log('Reached the last slide');
                    // },
                    // resize: function () {
                    //     _self.slidesPerDisplay = this.params.slidesPerView;
                    // },
                },
            });
        });
    },
}));

Alpine.data('CompareNotification', () => ({
    openNotification: false,
    closeNotification() {
        this.openNotification = false;
    },
    toggleNotification() {
        this.openNotification = !this.openNotification;
    },

}));
Alpine.data('ComingSoonNotifyMe', () => ({
    step: null,
    propTypes: ['any'],
    beds: ['any'],
    inputLength: 0,

    init() {
        var _self = this;

        this.form = $(this.$refs.smart_search_form).validate({
            errorElement: "span",
            errorClass: "text-danger",
            rules: {
                email: {
                    required: true,
                    email: true,
                },
            },
            messages: {
                email: {
                    required: 'The email field is required',
                },
            },
            errorPlacement: function (error, element) {
                $('#server_email_error').hide();
                error.insertAfter(element);
            },
            submitHandler: function (form, event) {
                event.preventDefault();
                $('#server_email_error').removeClass('text-danger').text('').show();
                if ($(form).valid()) {
                    if (_self.step == 3) {
                        var formData = $(form).serializeArray();
                        var formDataObject = {};
                        formData.forEach(function (field) {
                            if (field.name.endsWith('[]')) {
                                // Remove the [] from the name to standardize the key
                                var key = field.name.slice(0, -2);
                                if (!formDataObject[key]) {
                                    formDataObject[key] = [];
                                }
                                formDataObject[key].push(field.value);
                            } else {
                                formDataObject[field.name] = field.value;
                            }
                        });
                        formDataObject['project_type'] = _self.propTypes;
                        formDataObject['beds'] = _self.beds;
                        $.ajax({
                            type: 'POST',
                            url: '/api/coming-soon-notify-me',
                            data: formDataObject
                        }).
                            done((response) => {
                                let event = new CustomEvent('close-modal');
                                window.dispatchEvent(event);
                                Livewire.emit('showAlert', {
                                    'type': 'Thank You!',
                                    'message': response.message,
                                    'button': true,
                                    'buttonText': 'Ok',

                                });
                            }).
                            fail((err) => {
                                $('#server_email_error').addClass('text-danger').text(err.responseJSON.errors.email.toString()).show();
                            })

                    } else {
                        _self.step++;
                    }
                    return;
                }
            }
        });
        this.$nextTick(() => {
            _self.step = 1
        })

    },
    resetFormAndTabs() {
        this.step = 1;
        this.propTypes = ['any'];
        this.beds = ['any'];
        this.inputLength = 0;
        $('#email').val('');

    },
    handlePropSelection(value, key) {
        let el = document.getElementById(`view-props-${value}-${key}`)
        if (value !== 'any') {
            if (this.propTypes.includes(value)) {
                var index = this.propTypes.findIndex((x) => x == value);
                this.propTypes.splice(index, 1);
                if (this.propTypes.length == 0) {
                    this.propTypes = ['any']
                }
            } else {
                this.propTypes.push(value)
                this.propTypes = [...new Set(this.propTypes.filter(bed => bed != 'any'))]
            }
        } else {
            this.propTypes = ['any']

        }


    },

    handleBedSelection(value) {
        if (value !== 'any') {
            if (this.beds.includes(value)) {
                this.beds = this.beds.filter(bed => bed !== value)
                this.beds = [...new Set(this.beds.filter(bed => bed != 'any'))]
                if (this.beds.length === 0) {
                    this.beds.push('any')
                }
            } else {
                this.beds.push(value)
                this.beds = [...new Set(this.beds.filter(bed => bed != 'any'))]
            }
        } else {
            this.beds = ['any']
        }
    },


}));
Alpine.data('SmartSearch', () => ({
    step: null, // temparory 0
    propTypes: ['any'],
    beds: ['any'],
    inputLength: 0,
    projectOrLocationSelections: ['any'],
    minPrice: 'any',
    maxPrice: 'any',
    loading: false,
    tagify: null,
    locationOptions: [
        {
            id: 'Dubai',
            text: 'Dubai',
            value: 'Dubai',
            state_name: 'Dubai',
            country_name: "United Arab Emirates"
        },
        {
            id: 'Abu Dhabi',
            text: 'Abu Dhabi',
            value: 'Abu Dhabi',
            state_name: 'Abu Dhabi',
            country_name: "United Arab Emirates"
        },

    ],
    selectedLocation: [],
    handlePrices(prices) {
        if (prices?.detail?.min) {
            this.minPrice = prices?.detail?.min;
        }
        if (prices?.detail?.max) {
            this.maxPrice = prices?.detail?.max;
        }
    },
    submitForm() {
    },
    chooseLocation(location) {
        var self = this;
        self.tagify.settings.whitelist = [];
        self.tagify.settings.whitelist = self.locationOptions;
        const index = self.tagify.value.findIndex((item) => item.value == location.value);
        if (index == -1) {
            self.selectedLocation.push(location);
            self.tagify.removeAllTags();
            self.tagify.addTags(self.selectedLocation);
            findPlaceCoordinates(location.text, location.id);
        }
    },
    formChange() {
        $(this.$refs.smart_search_form).valid()
        $('#tagable-error').addClass('h-5 bg-transparent error')
    },

    init() {
        var _self = this;
        _self.step = 1;
        this.form = $(this.$refs.smart_search_form).validate({
            rules: {
                taggable: {
                    required: true,
                },
            },
            messages: {
                taggable: {
                    required: 'You must enter at least one location',
                },
            },
            submitHandler: function (form) {
                if ($(form).valid()) {
                    _self.step++;
                }
            }
        });

        function tagTemplate(tagData) {
            return `
                        <tag title="${tagData.text}"
                                contenteditable='false'
                                spellcheck='false'
                                tabIndex="-1"
                                class="tagify__tag ${tagData.class ? tagData.class : ""}"
                                ${this.getAttributes(tagData)}>
                            <x title='' class='tagify__tag__removeBtn' role='button' aria-label='remove tag'></x>
                            <div>
                                <span class='tagify__tag-text'>${tagData.text}</span>
                            </div>
                        </tag>
                    `
        }
        window.onload = function () {
            //_self.step = 1;
        };

        var self = this
        self.$nextTick(() => {
            var inputElm = document.getElementById('tagable'),
                whitelist = [];
            if (inputElm) {
                inputElm?.setAttribute('aria-label', 'Property tags');
                inputElm?.setAttribute('aria-labelledby', 'property-tags-label');;
            }
            // initialize Tagify on the above input node reference
            self.tagify = new Tagify(inputElm, {
                enforceWhitelist: true,
                templates: {
                    tag: tagTemplate,
                },
                delimiters: '!',
                maxTags: 10,
                skipInvalid: false,
                editTags: false,
                whitelist: inputElm?.value.trim().split(/\s*,\s*/) // Array of values. stackoverflow.com/a/43375571/104380
            })

            function togglePlaceholder() {

                // console.log(tagify,'---55-');
            }

            function debounce(func, delay) {
                let timeoutId;
                return function () {
                    const context = this;
                    const args = arguments;

                    clearTimeout(timeoutId);
                    timeoutId = setTimeout(function () {
                        func.apply(context, args);
                    }, delay);
                };
            }
            // Chainable event listeners
            self.tagify.on('add', onAddTag)
                .on('remove', onRemoveTag)
                .on('input', debounce(onInput, 250))
                .on('edit', onTagEdit)
                .on('invalid', onInvalidTag)
                .on('click', onTagClick)
                .on('focus', onTagifyFocusBlur)
                .on('blur', onTagifyFocusBlur)
                .on('dropdown:hide dropdown:show', e => togglePlaceholder())
                .on('dropdown:select', onDropdownSelect)

            // tag added callback
            function onAddTag(e) {
                projectOrLocationSelections = self.tagify.value.map(x => x.text);
                _self.inputLength = projectOrLocationSelections.length
            }

            // tag remvoed callback
            function onRemoveTag(e) {
                self.tagify.loading(false)
                var index = projectOrLocationSelections.findIndex(x => x == e.detail.data.text);
                var indexLoca = self.selectedLocation.findIndex(x => x.text == e.detail.data.text);
                if (index != -1) {
                    projectOrLocationSelections.splice(index, 1);
                    if (indexLoca != -1) {
                        self.selectedLocation.splice(indexLoca, 1);

                    }
                    removeMarker(e.detail.data.id);
                }
                _self.inputLength = projectOrLocationSelections.length
                if (!self.tagify.value.length) {
                    self.step = 1;
                }
            }


            // on character(s) added/removed (user is typing/deleting)
            function onInput(e) {
                self.tagify.whitelist = null; // reset current whitelist
                self.tagify.loading(false) // show the loader animation
                var term = e.detail.value;
                // get new whitelist from a delayed mocked request (Promise)
                /* item.value = item.text + ( item?.region_title || item?.state_name ? " ("+ (item?.region_title ? item?.region_title+', ' : '' ) +item?.state_name + ") " : ''); */
                axios.get('/api/local/projects-or-locations', {
                    params: {
                        term: term.value,
                        q: term,
                        countryId: window.global.country_id
                    }
                })
                    .then(function (result) {
                        var data = result.data.results.map(item => {
                            item.value = `${item.text} (${item.country_name})`;
                            if (item.all_region_title && item.all_region_title == item.text) {
                                item.value = item.text + ` (${item.state_name}, ${item.country_name})`;
                            } else {
                                if (item.all_region_title) {
                                    item.value = item.text + " (" + removeTextFromCSV(item?.all_region_title, item.text) + ", " + `${item.state_name}, ${item.country_name}` + ")";
                                }
                            }
                            return item;
                        });
                        self.tagify.settings.whitelist = data.concat(self.tagify.value) // add already-existing tags to the new whitelist array

                        self.tagify
                            .loading(false)
                            // render the suggestions dropdown.
                            .dropdown.show(e.detail.value);
                    })
                    .catch(err => self.tagify.dropdown.hide())
            }

            function onTagEdit(e) {
                // console.log("onTagEdit: ", e.detail);
            }



            // invalid tag added callback
            function onInvalidTag(e) {
                if (!self.tagify.value.length) {
                    self.step = 1;
                }
                if (e.detail.tagify.value.length > 3) {
                    setTimeout(() => {
                        $('#tagable-error').text('You can enter up to 10 locations only').css('display', 'block')
                    }, 1000);

                    setTimeout(() => {
                        $('#tagable-error').text('')
                    }, 2000);
                }
            }

            // invalid tag added callback
            function onTagClick(e) {
                // console.log("onTagClick: ", e.detail);
            }

            function onTagifyFocusBlur(e) {
                // console.log(e.type, "event fired")
            }

            async function onDropdownSelect(e) {
                self.tagify
                    .loading(false)
                // if (tagify.value.length <= 3) {
                // self.step = 1;
                var data = e.detail.tagify.value.map(x => x.text);

                data.push(e.detail.data.text);
                await $.ajax({
                    url: '/api/local/check-search-selection',
                    data: {
                        data: data,
                        selected: e.detail.data.text
                    },
                    success: function (res) {
                        var temp = self.tagify.value;
                        var data = self.tagify.whitelist.filter(y => (res.locations.map(x => x.text)).includes(y.id));
                        const uniqueIds = [];

                        const unique = data.filter(element => {
                            const isDuplicate = uniqueIds.includes(element.id);
                            if (!isDuplicate) {
                                uniqueIds.push(element.id);

                                return true;
                            }

                            return false;
                        });

                        self.tagify.removeAllTags()
                        self.tagify.addTags(unique.map(x => x.value).join('!'))
                        var removedItems = temp.filter(temp => !unique.map(x => x.text).includes(temp.text));
                        if (removedItems.length > 0) {
                            removedItems.forEach(element => {
                                removeMarker(element.text);
                            });
                        }

                    },
                    complete: function () {
                        // This function is called when the request is completed (either success or error)
                        if (self.tagify.value.length <= 3) {

                            if (e.detail.data.hasOwnProperty('latitude') && e.detail.data.hasOwnProperty('longitude')) {

                                let place = {
                                    geometry: {
                                        location: {
                                            lat: parseFloat(e.detail.data.latitude),
                                            lng: parseFloat(e.detail.data.longitude)
                                        }
                                    }
                                };

                                createMarker(place, e.detail.data.text, e.detail.data.id);
                                setMapZoom(place);
                            } else {
                                findPlaceCoordinates(e.detail.data.text, e.detail.data.id);
                            }
                        }
                    },
                });

                // }

            }
        });

    },
    handlePropSelection(value, key) {
        let el = document.getElementById(`view-props-${value}-${key}`)
        if (value !== 'any') {
            if (this.propTypes.includes(value)) {
                var index = this.propTypes.findIndex((x) => x == value);
                this.propTypes.splice(index, 1);
                if (this.propTypes.length == 0) {
                    this.propTypes = ['any']
                }
            } else {
                this.propTypes.push(value)
                this.propTypes = [...new Set(this.propTypes.filter(bed => bed != 'any'))]
            }
        } else {
            this.propTypes = ['any']

        }


    },

    handleBedSelection(value) {
        if (value !== 'any') {
            if (this.beds.includes(value)) {
                this.beds = this.beds.filter(bed => bed !== value)
                this.beds = [...new Set(this.beds.filter(bed => bed != 'any'))]
                if (this.beds.length === 0) {
                    this.beds.push('any')
                }
            } else {
                this.beds.push(value)
                this.beds = [...new Set(this.beds.filter(bed => bed != 'any'))]
            }
        } else {
            this.beds = ['any']
        }
    },

    handleProjectRegionSelection(e) {
        if (e.type == 'add') {
            this.projectOrLocationSelections = this.projectOrLocationSelections.filter(item => item != 'any')
            this.projectOrLocationSelections.push(e.id)
        } else {
            this.projectOrLocationSelections = this.projectOrLocationSelections.filter(item => item != e.id)
            if (this.projectOrLocationSelections.length == 0)
                this.projectOrLocationSelections.push('any')
        }
    },

    // if 'any' and it is checked ==> keep only 'any'
    checkedTypeAny(event) {
        let self = this;
        if (event.target.id == 'any_id' && event.target.checked) {
            self.selectedTypes = ['any'];
        }
    },

    uncheckTypeAny() {
        let self = this;
        // if at least one of selected then uncheck any
        self.selectedTypes = self.selectedTypes.filter(elem => {
            if (elem != 'any') {
                return elem;
            }
        })
        // If all checked => uncheck all, and set 'any'
        if (self.selectedTypes.length == 6) {
            self.selectedTypes = ['any'];
        }

        if (self.selectedTypes.length == 0) {
            self.selectedTypes = ['any'];
        }
    },

    checkedBedAny(event) {
        let self = this;
        if (event.target.id == 'bed_any_id' && event.target.checked) {
            self.selectedBeds = ['any_beds'];
        }
    },

    uncheckBedAny() {
        let self = this;
        // if at least one of selected then uncheck any
        self.selectedBeds = self.selectedBeds.filter(elem => {
            if (elem != 'any_beds') {
                return elem;
            }
        })
        // If all checked => uncheck all, and set 'any'
        if (self.selectedBeds.length == 12) {
            self.selectedBeds = ['any_beds'];
        }

        if (self.selectedBeds.length == 0) {
            self.selectedBeds = ['any_beds'];
        }
    },
    completeSearch() {
        this.loading = true;

        // Base URL for search
        let baseSearchUrl = window.global.search_page_url;
        let queryParam = new URLSearchParams();

        // Handling project or location selections
        let selections = projectOrLocationSelections.length > 0 ? projectOrLocationSelections : this.projectOrLocationSelections;
        selections.forEach((item, index) => {
            queryParam.append(`projectOrLocationSelection[${index}]`, item.toString());
        });

        // Price filters
        queryParam.append('minPrice', this.minPrice === '' ? 'any' : this.minPrice);
        queryParam.append('maxPrice', this.maxPrice === '' ? 'any' : this.maxPrice);

        // Beds filter
        this.beds.forEach((item, index) => {
            if (item === '10+') {
                item = '10%2B'; // Encode '+' as '%2B'
            }
            queryParam.append(`beds[${index}]`, item);
        });

        // Property types
        this.propTypes.forEach((item, index) => {
            queryParam.append(`propTypes[${index}]`, item);
        });

        // Redirect with the final query string
        const searchUrl = `${baseSearchUrl}?${queryParam.toString()}`;
        setTimeout(() => {
            window.location = searchUrl;
        }, 500);
    }
    ,
    completeSesarch() {
        this.loading = true;
        // Regions

        let queryParam = '?'

        //
        let baseSearchUrl = window.global.search_page_url;
        if (projectOrLocationSelections.length > 0) {
            projectOrLocationSelections.forEach((item, index) => {
                queryParam += `projectOrLocationSelection[${index}]=${item.toString()}&`
            })
        } else {
            this.projectOrLocationSelections.forEach((item, index) => {
                queryParam += `projectOrLocationSelection[${index}]=${item}&`
            })
        }
        queryParam += `minPrice=${this.minPrice == '' ? 'any' : this.minPrice}&`
        queryParam += `maxPrice=${this.maxPrice == '' ? 'any' : this.maxPrice}&`

        this.beds.forEach((item, index) => {
            if (item == '10+') {
                item = '10%2B';
            }
            queryParam += `beds[${index}]=${item}&`
        })

        this.propTypes.forEach((item, index) => {

            queryParam += `propTypes[${index}]=${item}&`
        })

        queryParam = queryParam.slice(0, -1)

        // console.log(queryParam);
        // console.log(encodeURI(queryParam.slice(0, -1)));

        // Redirect with params
        setTimeout(() => {
            // window.location = baseSearchUrl + queryParam;
        }, 500);

    },
}));

function triggerTrackImpression() {
    const result = manageBuyPagePropertyIds(projects, 'home_page_projects', 'home_page_projects_timestamp');
    if (result.Newly_Added_IDs.length > 0) {
        axios.post(`/${window.global.country_code}/track-project-impression`, {
            'projects': result.Newly_Added_IDs
        }).then((result) => {
            // console.log(result.data);
        }).catch((err) => {
            // console.log(err.response.data);

        });
    }
}

Alpine.data('sameAndSimilarPropertiesTab', () => ({
    tab: 'developer_properties',
    init() {
        this.$watch('$store', (newVal) => {
            const store = newVal.sameAndSimilarPropertiesTabStore;
            if (store.same_developer_properties_count == 0 && store.similar_properties_count != 0) {
                this.tab = 'similar_properties';
            } else {
                this.tab = 'developer_properties';
            }
        })


    }
}));

Alpine.data('DesignationComponent', () => ({

    onChange($event) {
        if ($event.target.value == '') {
            $(`.menu-item`).prop("checked", false);
            return;
        }
        const option = $event.target.selectedOptions[0]; // get selected option
        const defaultPermision = JSON.parse(option.dataset.value).default_permisison;

        if (defaultPermision == 'all') {
            $(`.menu-item`).prop("checked", true);
        } else {
            defaultPermision.forEach((res) => {

                $(`.menu-item`).prop("checked", false);
                setTimeout(() => {
                    $(`#permission_${res}`).prop("checked", true);
                }, 100);
                // $(`#permission_${res}`).value(true);
            })
        }
    },
    init() {


        // this.$watch('$store', (newVal) => {

        // })


    }
}));


Alpine.store('sameAndSimilarPropertiesTabStore', {
    same_developer_properties_count: 0,
    similar_properties_count: 0,
    updateSameProperties(count) {
        this.same_developer_properties_count = count;
    },
    updateSimilarProperties(count) {
        this.similar_properties_count = count;
    },
});

Alpine.data('mortgageCalculator', (props) => ({
    price: 150000,
    downPayment: 0,
    currency: "AED",
    years: 25,
    during_construction: 25,
    interestRate: 4,
    handlePrice($event) {
        this.currency = $event.detail.currency;
        this.price = $event.detail.price;
        this.downPayment = ((this.during_construction / 100) * this.price).toFixed(2);

    },
    init() {
        var self = this;
        self.$nextTick(() => {
            self.price = props.price;
            self.during_construction = props.during_construction;
            self.downPayment = ((self.during_construction / 100) * self.price).toFixed(2);
        })
    },
    get monthlyPayment() {
        const principal = this.price - this.downPayment;
        const months = this.years * 12;
        const monthlyRate = (this.interestRate / 100) / 12;

        if (monthlyRate === 0) return (principal / months);

        const factor = Math.pow(1 + monthlyRate, months);

        return (principal * monthlyRate * factor / (factor - 1));
    },
}));


Alpine.data('FCMServerKey', () => ({
    token: '',
    isCopied: false,
    init() {
        this.$nextTick(() => {
        })
        this.getServerKey();
    },
    getServerKey() {
        axios.get('/uac/get-fcm-server-key').then((res) => {
            this.token = res.data.value;
        }).catch((e) => {


        });

    },
    handleFunction() {

        Swal.fire({
            title: 'Confirmation',

            html: 'Are You sure you want to refresh the FCM Key?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3D3CE2',
            cancelButtonColor: '#7A7A7A',
            showCloseButton: false,

            toast: true,
            customClass: {
                // cancelButton: 'cancel-custom-class',
                // confirmButton: 'confirm-custom-class'
            },
            confirmButtonText: 'Yes, Confirm',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.post('/uac/uac-refresh-fcm-server-key').then((res) => {
                        this.token = res.data.access_token;
                    }).catch((e) => {


                    });
                }
            });


    },
    copyToClipBoard() {
        if (!navigator.clipboard) {
            textArea = document.createElement('textarea');
            textArea.value = this.$refs.content.innerHTML;

            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.position = 'fixed';

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                if (document.execCommand('copy')) {
                    this.isCopied = true;
                    setTimeout(() => {
                        this.isCopied = false;
                    }, 2500);
                }
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }

            document.body.removeChild(textArea);
            return;
        } else {
            navigator.clipboard.writeText(this.token)
                .then(() => {
                    this.isCopied = true;
                    setTimeout(() => {
                        this.isCopied = false;
                    }, 2500);
                });
        }
    }
}));
Alpine.data('reviewModal', (props) => ({
    isOpen: false,
    rating: 0,
    isLoading: false,
    ratings: [],
    review: "",
    showCreateForm: false,
    project_id: "",
    developer_id: "",
    success_message: "",
    sort: "latest",
    reviews: [],
    categoryAvgCount: null,
    ratingsinput: {
        location: 0,
        developer: 0,
        design: 0,
        amenities: 0,
        roi: 0,
    },
    async getProjectRevies(sort = 'latest') {
        this.isLoading = true;
        await axios.get(window.global.base_url + '/' + window.global.country_code + '/project-reviews/' + this.developer_id + '/' + this.project_id, {
            params: {
                sort: sort,
            }
        }).then((res) => {

            this.reviews = res.data.data
            this.ratings = res.data.ratingCounts
            this.categoryAvgCount = res.data.categoryAvgCount;
            setTimeout(() => {
                this.isLoading = false;
            }, 0);
        }).catch(() => {
            this.isLoading = false;

        })
    },
    submitReply(review) {
        if (!review.reply) return;

        // example AJAX call
        fetch(window.global.base_url + '/' + window.global.country_code + '/reply-project-reviews/' + review.developer_id + '/' + review.project_id ?? '', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]').content
            },
            body: JSON.stringify({
                review_id: review.id,
                reply: review.reply
            })
        }).then(() => {
            review.reply = '';
            review.showReply = false;
            Livewire.emit('showAlert', { 'message': 'We have successfully received your review.', type: '', 'button': true, 'buttonText': 'Continue Search' });
        }).catch((error) => {
        });
    },
    isTermsOpen: false,
    OpenTerms() {
        this.isTermsOpen = true;
    },
    CloseTerms() {
        this.isTermsOpen = false;
    },
    getCategoryValue(type) {
        return this.categoryAvgCount != null ? this.categoryAvgCount[type] : '0';
    },
    openWriteAReviewForm() {
        if (!window.global.user_id) {
            const login = document.getElementById('login_modal_button').click()
            return;
        }
        this.showCreateForm = true;
    },
    closeWriteAReviewForm() {
        this.resetForm();
        this.showCreateForm = false;
    },

    get totalRating() {
        if (!this.reviews.length) {
            return 0; // or '0.00' based on your UI
        }

        const sum = this.reviews.reduce(
            (total, r) => total + (parseFloat(r.rating) || 0),
            0
        );

        return (sum / this.reviews.length).toFixed(1); // 1 decimal
    }
    ,
    sortedReviews() {
        if (this.sort === 'highest')
            return this.reviews.slice().sort((a, b) => b.rating - a.rating);

        if (this.sort === 'lowest')
            return this.reviews.slice().sort((a, b) => a.rating - b.rating);

        return this.reviews.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
    init() {
        let self = this;
        self.project_id = props?.project_id ?? null;
        self.developer_id = props.developer_id ?? null;
        self.$watch('sort', (Val) => {
            self.getProjectRevies(Val);
        })
        self.getProjectRevies();
        self.$nextTick(() => {
            const validator = $(self.$refs.ratingReviews).validate({
                ignore: [],
                rules: {
                    rating: {
                        required: true,
                        min: 1
                    },
                    review: {
                        required: false,
                        maxlength: 500
                    },
                    project_id: {
                        required: false,
                    },
                    location: {
                        required: true,
                        min: 1
                    },
                    developer: {
                        required: true,
                        min: 1
                    },
                    design_or_floorplan: {
                        required: true,
                        min: 1
                    },
                    amenities: {
                        required: true,
                        min: 1
                    },
                    return_on_investment: {
                        required: true,
                        min: 1
                    },
                },
                messages: {
                    rating: "Please select a star rating.",
                    review: {
                        required: "Please write a review.",

                    },
                    location: {
                        required: 'This is required field',
                        min: 'Please rate all categories.'
                    },
                    developer: {
                        required: 'This is required field',
                        min: 'Please rate all categories.'
                    },
                    design_or_floorplan: {
                        required: 'This is required field',
                        min: 'Please rate all categories.'
                    },
                    amenities: {
                        required: 'This is required field',
                        min: 'Please rate all categories.'
                    },
                    return_on_investment: {
                        required: 'This is required field',
                        min: 'Please rate all categories.'
                    }
                },

                highlight: function (element) {
                    $(element).addClass("border-red-900 shake");

                    setTimeout(() => {
                        $(element).removeClass("border-red-900 shake");
                    }, 300);
                },
                errorPlacement: function (error, element) {
                    if (element.attr("name") == 'rating') {
                        error.appendTo("#review-ui-error");

                    } else if (element.attr("name") == 'location') {
                        $('#review-ui-error-mixed').empty();
                        error.appendTo('#review-ui-error-mixed');
                    } else if (element.attr("name") == 'developer') {
                        $('#review-ui-error-mixed').empty();
                        error.appendTo('#review-ui-error-mixed');
                    } else if (element.attr("name") == 'design_or_floorplan') {
                        $('#review-ui-error-mixed').empty();
                        error.appendTo('#review-ui-error-mixed');
                    } else if (element.attr("name") == 'amenities') {
                        $('#review-ui-error-mixed').empty();
                        error.appendTo('#review-ui-error-mixed');
                    } else if (element.attr("name") == 'return_on_investment') {
                        $('#review-ui-error-mixed').empty();
                        error.appendTo('#review-ui-error-mixed');
                    } else {
                        error.insertAfter(element);
                    }
                },
                submitHandler: function (form, event) {
                    event.preventDefault();

                    let formData = $(form).serializeArray();

                    formData = formData.filter(field => {
                        return !field.name.startsWith("breakdown[");
                    });

                    let formDataObject = {};
                    formData.forEach(function (field) {
                        if (field.name.endsWith('[]')) {
                            let key = field.name.slice(0, -2);
                            if (!formDataObject[key]) {
                                formDataObject[key] = [];
                            }
                            formDataObject[key].push(field.value);
                        } else {
                            formDataObject[field.name] = field.value;
                        }
                    });

                    axios.post($(form).attr('action'), formDataObject).then((res) => {

                        self.$refs.ratingReviews.reset();
                        Livewire.emit('showAlert', { 'message': res.data.message, 'type': '', 'button': true, 'buttonText': 'Continue Search' })
                        self.closeWriteAReviewForm();
                        self.close();

                    });
                    // console.log("✓ Validated form data:", formDataObject);
                }
            });
        });
    },
    toggleScroll(isRemove = true) {
        var event = new CustomEvent('manageScroll', {
            detail: { action: isRemove }
        });
        window.dispatchEvent(event);
    },
    resetForm() {
        var self = this;
        self.$refs.ratingReviews.reset();
    },
    open() {
        this.toggleScroll(true);
        this.resetForm();
        setTimeout(() => {
            this.showCreateForm = false;
            this.isOpen = true;
        }, 0);

    },
    close() {
        this.toggleScroll(false);
        this.isOpen = false;
        this.resetForm();
    },

    setRating(value) {
        this.rating = value;
    }
}));
// Alpine.data('Pricing', () => ({
//     open: 'monthly',
//     monthly: true,
//     countries: [],
//     states: [],
//     cities: [],
//     handleTagify(e){
//         console.log(e,'Yameen');
//     },
//     formChange() {
//         $('#create-agent-account').valid()
//         $('#tagable-error').addClass('h-5 bg-transparent error')
//     },
//     init() {
//         const _self = this;
//         $.ajaxSetup({
//             headers: {
//                 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//             }
//         });

//         $.validator.addMethod("passwordPattern", function (value, element) {
//             return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/.test(value);
//         }, "Password must contain uppercase, number and lowercase letters");

//         $.validator.addMethod("validNamePattern", function (value, element) {
//             return /^[a-zA-Z0-9\s]+$/.test(value);
//         }, "Letters and numbers only");


//         $.validator.addMethod("validEmailPattern", function (value, element) {
//             return /^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
//         }, "Please enter valid email");
//         // ── Option 3: Always return canonical (no www) version ────────────
//         function extractDomain(text) {
//             const match = text.match(/https?:\/\/(www\.)?([a-zA-Z0-9.-]+\.[a-z]{2,})/);
//             if (!match) return null;
//             return match[2]; // strips www, returns "xploon.com"
//         }

//         $.validator.addMethod("checkDomain", function (value, element) {
//             const websiteUrl = $('#company_website').val().trim();
//             const domain = extractDomain(websiteUrl);
//             if (!domain) return false;
//             const escapedDomain = domain.replace(/\./g, '\\.');
//             const regex = new RegExp('^[a-zA-Z0-9._%+\\-]+@' + escapedDomain + '$', 'i');
//             return regex.test(value);
//         }, function () {
//             const domain = extractDomain($('#company_website').val().trim());
//             return 'Email must be from @' + (domain ?? 'your website domain');
//         });

//         $('#create-agent-account').validate({
//             ignore: [],
//             rules: {
//                 business_email: {
//                     required: true,
//                     validEmailPattern: true,
//                     email: true,
//                     // checkDomain: true
//                 },
//                 password: {
//                     required: true,
//                     minlength: 8,
//                     passwordPattern: true
//                 },
//                 password_confirmation: {
//                     required: true,
//                     equalTo: "#password"
//                 },
//                 city: "required",
//                 country: "required",
//                 company_name: "required",
//             },
//             errorPlacement: (error, element) => {

//                 let password = element.attr('name') == 'password';
//                 let password_confirmation = element.attr('name') == 'password_confirmation';
//                 let confirm_consent_employee = element.attr('name') == 'confirm_consent_employee';
//                 let confirm_terms_condition = element.attr('name') == 'confirm_terms_condition';

//                 if (confirm_consent_employee) {
//                     error.appendTo(element.siblings(".error-container"));
//                 } else if (confirm_terms_condition) {
//                     error.appendTo(element.siblings(".error-container"));
//                 } else if (password) {
//                     error.appendTo(element.parent().siblings(".error-container-password"));
//                 } else if (password_confirmation) {
//                     error.appendTo(element.parent().siblings(".error-container-confirm"));
//                 }
//                 else {
//                     error.insertAfter(element);
//                 }
//             },
//             submitHandler: function (form) {

//                 $.ajax({
//                     url: $(form).attr('action'),
//                     method: "POST",
//                     data: $(form).serialize(),
//                     beforeSend: function () {

//                         $("button[type='submit']").text("Submitting...")

//                     },
//                     success: function (response) {

//                         // alert("Form submitted successfully")

//                         $("#create-agent-account")[0].reset()

//                     },
//                     error: function () {

//                         console.log("Something went wrong")

//                     },
//                     complete: function () {

//                         $("button[type='submit']").text("Submit")

//                     }

//                 })

//                 return false

//             }
//         });

//         this.$nextTick(() => {
//             _self.getCountries();
//         });

//     },
//     getCountries() {
//         axios.get('/api/local/countries/null').then((result) => {
//             this.countries = result.data.results;
//         }).catch((error) => {
//             this.countries = [];
//             console.log(error);

//         });
//     },
//     fetchStates($event) {
//         axios.get(`/api/local/states`, {
//             params: {
//                 'country_id': $event.target.value,
//             }
//         }).then((result) => {
//             this.states = result.data.results;
//         }).catch((error) => {
//             this.states = [];
//         });
//     },
// }));
Alpine.data('paymentPlanBreakdown', (props) => ({
    items: [],
    // init() {
    //     this.$nextTick(() => {
    //         if (!(props.selected == '' || props.selected == null)) {
    //             this.items = JSON.parse(props.selected);
    //         }
    //         this.updateFields();
    //     })
    // },

    init() {
        this.$nextTick(() => {
            if (props.selected && Array.isArray(props.selected)) {
                this.items = props.selected;
            } else {
                if (!(props.selected == '' || props.selected == null)) {
                    this.items = JSON.parse(props.selected);
                }
            }
            this.updateFields();
        });
    },

    addMore() {
        this.items.push({
            id: this.items.length + 1,
            installment: '',
            percentage: 0,
            milestone: this.items.length == 0 ? 'Immediate' : '',
        });
    },
    copyItem(item, index) {
        if (this.totalPercentage >= 100) return;
        let text = item.milestone == 'Immediate' ? 'Within 1 months' : item.milestone;

        let number = parseInt(text.match(/\d+/)[0]);
        number++;
        ++index;
        let updatedText = text.replace(/\d+/, number);
        let percentage = parseFloat(item.percentage);
        var total = (parseFloat(this.items.reduce((sum, i) => sum + Number(i.percentage || 0), 0)));

        if ((total + percentage) > 100) {
            console.log(total);
            percentage = 100 - total;
        }

        this.items.push({
            id: index,
            installment: '',
            percentage: percentage,
            milestone: updatedText,
        });
    },
    remove(item, index) {
        this.items.splice(index, 1)
    },
    get totalPercentage() {
        const total = this.items.reduce((sum, i) => sum + Number(i.percentage || 0), 0);;
        return total;
    },
    onInput($event, index) {
        if (this.totalPercentage >= 100) {
            this.items[index].percentage = ($event.target.value - (this.totalPercentage - 100));
            setTimeout(() => {
                this.items = this.items.filter(x => x.percentage !== 0);
            }, 0);

        }
        this.updateFields();
    },
    updateFields() {
        setTimeout(() => {
            var event = new CustomEvent('payment_breakdown_payload', {
                detail: this.items
            });
            window.dispatchEvent(event);
        }, 0);
    },
}))
Alpine.data('pPlanBreakdownModal', () => ({
    open: false,
    init() {
        this.$watch('open', (newVal, oldVal) => {
            if (newVal) {
                document.body.classList.add("modal-open");
            } else {
                document.body.classList.remove("modal-open");
            }
        })
    }
}));

Alpine.data('billingTabs', (initialData) => ({
    selectedId: initialData.tab,
    isErrorOnBilling: false,
    isErrorOnContact: false,
    data: initialData,
    isLoading: false,
    countries: [],
    disable_submit_button: true,
    active: 'pb-2 border-b-2 border-indigo-600 text-indigo-600 font-semibold',
    inactive: 'pb-2 text-gray-500 hover:text-gray-700',
    isChangedMethod: false,
    stripe: null,
    clientSecret: null,
    cardElement: null,
    cardElementError: '',
    init() {
        var _self = this;
        $("#payment_form").validate({
            ignore: [],
            rules: {
                cardElementField: {
                    required: true
                }
            },
            submitHandler: function (form) {

                _self.getPaymentId(initialData.user, 3, _self.clientSecret).then(result => {
                    _self.isChangedMethod = false;
                    _self.data.paymentMethods = result?.data?.card;
                    _self.data.paymentMethods = result?.data?.card;
                    _self.data.paymentMethods['card_brand'] = result.data.card?.brand;
                    _self.data.paymentMethods['has_card'] = true
                    window.location.reload();
                }).catch(error => {


                });

                // DO NOT call form.submit()
                return false;
            }
        });

        window.addEventListener('swal:callback', ($event) => {
            _self.chagePaymentMethod($event.detail.user_id);
        })

        window.addEventListener('change-tab', ($event) => {
            this.select($event.detail);
        })

        this.$nextTick(() => {
            if (window.location.hash) {
                _self.select(window.location.hash.replace('#', ''));
            }
            _self.getCountries();
        });
        window.addEventListener('refreshBillingPage', () => {
            _self.refreshBillingPage();
        })
        // _self.refreshBillingPage();
    },
    formatDate(date) {
        return new Date(date).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    },
    refreshBillingPage() {
        axios.get(window.location.href, {
            headers: {
                accept: 'application/json',
                contentType: 'application/json'
            }
        }).then((result) => {
            this.data = result.data;
            // console.log(result.data);

        }).catch((error) => {
            console.log(error);

        });
    },
    /* Manage Tabs */
    select(id) {
        this.selectedId = id
        this.isErrorOnBilling = false;
        this.isErrorOnContact = false;
        window.location.hash = id;
    },
    isSelected(id) {
        return this.selectedId === id
    },
    /* Manage Tabs */
    getCountries() {
        axios.get(`/api/local/countries/null?search=United%20Arab%20Emirates`).then((result) => {
            this.countries = result.data.results;
        }).catch((error) => {
            this.countries = [];
            console.log(error);

        });
    },
    confirmChangePayment(user_id) {
        Livewire.emit('alertConfirm', {
            'html': true,
            'text': 'Please confirm: do you want to update your payment method?',
            'arguments': {
                user_id: user_id,
            },
            'callback': 'mytestFunctson',
            'type': 'error'
        })
    },

    async chagePaymentMethod(userId) {
        axios.get($("#payment_form").data('intent')).then((res) => {
            this.clientSecret = res.data.intent.client_secret;
        })


        this.isChangedMethod = true; // 👈 Add this line

        this.stripe = Stripe(initialData.apiSecret);

        const elements = this.stripe.elements();
        this.cardElement = elements.create('card', {
            hidePostalCode: true,
            disableLink: true,
        });
        this.cardElement.mount('#card-element');
        this.cardElement.on('change', async (event) => {
            $('input[name="cardElementField"]').empty().val(event.complete ? event.complete : '')
            if (event.complete) {
                this.cardElementError = '',
                    this.disable_submit_button = false;
            } else {
                this.disable_submit_button = true;
                this.cardElementError = event?.error ? (event?.error?.message) : '';
            }
        });
    },

    getPaymentId(user, retries = 2, clientSecret = this.clientSecret) {
        this.isLoading = true;
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    setupIntent,
                    error
                } = await this.stripe.confirmCardSetup(
                    clientSecret, {
                    payment_method: {
                        card: this.cardElement,
                        billing_details: {
                            name: `${user.first_name} ${user.last_name}`,
                            email: user.email,
                            address: {
                                line1: document.getElementById('address_line1').value,
                                city: document.getElementById('address_city').value,
                                country: document.getElementById('address_country').value,
                            }
                        }
                    }
                }
                );

                if (error) {
                    console.error("Stripe Error:", error);

                    if (retries > 0) {
                        try {
                            const res = await fetch($('#payment_form').data('intent'), {
                                method: "GET",
                                headers: {
                                    'Content-Type': 'application/json',
                                    'accept': 'application/json',
                                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                },
                            });

                            const data = await res.json();

                            if (!res.ok) {
                                throw new Error(data.message || 'Failed to fetch client secret');
                            }

                            // 🔁 Recursive retry
                            return resolve(
                                this.getPaymentId(
                                    user,
                                    retries - 1,
                                    data.intent.client_secret
                                )
                            );
                        } catch (fetchError) {
                            return reject(fetchError);
                        }
                    }

                    return reject(error);
                }

                // ✅ Save payment method
                const result = await fetch($('#payment_form').attr('action'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    body: JSON.stringify({
                        payment_method_id: setupIntent.payment_method
                    })
                })


                const data = await result.json();

                if (!result.ok) {
                    throw new Error(data.message || 'Failed to fetch client secret');
                }
                // data.paymentMethods 
                resolve(data);



            } catch (err) {
                reject(err);
            } finally {
                this.isLoading = false;
            }
        });
    },
}));

Alpine.data('approveDisApproveAccount', () => ({
    form: null,
    showApproval: false,
    formName: '',
    loading: false,
    showDecline: false,
    reason: '',
    title: '',
    alert(type, message) {
        var eventError = new CustomEvent('alert', { detail: { message: message, type: type } });
        window.dispatchEvent(eventError);
    },
    init() {
        var _self = this;

        this.$watch('showApproval', (newVal, oldVal) => {
            if (newVal) {
                document.body.classList.add("modal-open");
            } else {
                document.body.classList.remove("modal-open");
            }
        });

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $(_self.$refs.approval_form).validate({
            rules: {
                reason: {
                    required: true
                }
            },
            submitHandler: (form, $event) => {
                $event.preventDefault();
                let formData = new FormData(form);

                $.ajax({
                    url: $(form).attr('action'),
                    method: $(form).attr('method'),
                    data: formData,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        $("button[type='submit']").text("Submitting...")
                    },
                    complete: () => {
                        $("button[type='submit']").text("Submit")

                    },
                    success: (res) => {
                        if (res.success) {
                            window.location.href = res.redirect;
                        }
                    },
                    error: (error) => {
                        $("button[type='submit']").text("Submit");
                        Livewire.emit('alert', {
                            'html': true,
                            'close': true,
                            'text': error.responseJSON.message,
                            'type': 'error'
                        }
                        );

                        // _self.alert('error', error.responseJSON.message);
                        // alert(error.responseJSON.message);
                    }
                })
            }
        });

        $(_self.$refs.disapprove_form).validate({
            rules: {
                reason: {
                    required: true
                }
            },
            submitHandler: (form, $event) => {
                $event.preventDefault();
                let formData = new FormData(form);

                $.ajax({
                    url: $(form).attr('action'),
                    method: $(form).attr('method'),
                    data: formData,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        $("button[type='submit']").text("Submitting...")
                    },
                    complete: () => {
                        $("button[type='submit']").text("Submit")

                    },
                    success: (res) => {
                        // Livewire.emit('alert', {
                        //     'html': true,
                        //     'text': error.responseJSON.message,
                        //     'type': res.success ? 'success' : 'error'
                        // })
                        if (res.success) {
                            window.location.href = res.redirect;
                        }
                    },
                    error: (error) => {
                        $("button[type='submit']").text("Submit");
                        Livewire.emit('alert', {
                            'html': true,
                            'text': error.responseJSON.message,
                            'type': 'error'
                        })
                    }
                })
            }
        });
        $(_self.$refs.developer_approval_form).validate({
            rules: {
                reason: {
                    required: true
                }
            },
            submitHandler: (form, $event) => {
                $event.preventDefault();
                let formData = new FormData(form);

                $.ajax({
                    url: $(form).attr('action'),
                    method: $(form).attr('method'),
                    data: formData,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        $("button[type='submit']").text("Submitting...")
                    },
                    complete: () => {
                        $("button[type='submit']").text("Submit")

                    },
                    success: (res) => {
                        // Livewire.emit('alert', {
                        //     'html': true,
                        //     'text': res.message,
                        //     'type': res.success ? 'success' : 'error'
                        // })
                        // console.log(res);

                        if (res.success) {
                            window.location.href = res.redirect;
                        }
                    },
                    error: (error) => {
                        $("button[type='submit']").text("Submit");
                        Livewire.emit('alert', {
                            'html': true,
                            'text': error.responseJSON.message,
                            'type': 'error'
                        })
                    }
                })
            }
        });
        $(_self.$refs.developer_disapprove_form).validate({
            rules: {
                reason: {
                    required: true
                }
            },
            submitHandler: (form, $event) => {
                $event.preventDefault();
                let formData = new FormData(form);

                $.ajax({
                    url: $(form).attr('action'),
                    method: $(form).attr('method'),
                    data: formData,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        $("button[type='submit']").text("Submitting...")
                    },
                    complete: () => {
                        $("button[type='submit']").text("Submit")

                    },
                    success: (res) => {
                        Livewire.emit('alert', {
                            'html': true,
                            'text': res.message,
                            'type': res.success ? 'success' : 'error'
                        })
                        if (res.success) {
                            window.location.href = res.redirect;
                        }
                    },
                    error: (error) => {
                        $("button[type='submit']").text("Submit");
                        Livewire.emit('alert', {
                            'html': true,
                            'text': error.responseJSON.message,
                            'type': 'error'
                        })
                    }
                })
            }
        });

    },
    openForm(title, showApprovalForm, formName = 'approval') {
        this.showApproval = !this.showApproval;
        this.title = title;
        this.formName = formName;
        this.showDecline = !showApprovalForm;
    },
    closeApproval() {
        this.showApproval = false;
    },
}));

Alpine.data('phoneInputComponent', ({ name, value = '' }) => ({
    iti: null,
    selectedCountry: 'ae',
    fullNumber: '',
    error: false,

    init() {
        let countryCode = 'us'; // fallback
        this.selectedCountry = 'ae';

        this.iti = window.intlTelInput(this.$refs.phoneInput, {
            nationalMode: false,
            hiddenInput: name,
            initialCountry: this.selectedCountry,
            preferredCountries: [this.selectedCountry],
            separateDialCode: true,
            placeholderNumberType: 'MOBILE',
            // loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@28.0.4/dist/js/utils.js"),
            utilsScript: "/vendor/intl-tel-input/build/js/utils.js?1684676252775"
        });
        if (value) {
            this.iti.setNumber(value ?? '');
        }

    },
    onInput() {

        console.log(this.iti.getNumber());
    }
}));
Alpine.data('stepForm', () => ({
    steps: ['Company Details', 'Projects Detail', 'Contract Agreement', 'Review'],
    current: 1,
    open: 1,

    toggle(step) {
        if (step <= this.current) {
            this.open = step
        }
    },

    next(step) {

        if ($("#multiForm").valid()) {
            this.current = step + 1
            this.open = step + 1
        }

    },

    back(step) {
        this.open = step
        this.current--;
    },

    init() {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.validator.addMethod("passwordPattern", function (value, element) {

            return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/.test(value);
        }, "Password must contain uppercase, number and lowercase letters");

        $.validator.addMethod("validNamePattern", function (value, element) {
            return /^[a-zA-Z0-9\s]+$/.test(value);
        }, "Letters and numbers only");


        $.validator.addMethod("validEmailPattern", function (value, element) {
            return /^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
        }, "Please enter valid email");



        $("#multiForm").validate({
            ignore: [],
            rules: {
                name: {
                    required: true,
                    validNamePattern: true
                },
                username: "required",
                trade_license: "required",
                rera: "required",
                projects_delivered: "required",
                projects_under_construction: "required",
                contact_number: "required",
                phone_number_for_customers: "required",
                email: {
                    required: true,
                    validEmailPattern: true,
                    email: true
                },
                password: {
                    required: true,
                    minlength: 8,
                    passwordPattern: true
                },
                password_confirmation: {
                    required: true,
                    equalTo: "#password"
                },
                city: "required",
                country: "required",
                notes: "required"
            },
            errorPlacement: (error, element) => {
                console.log(element.attr('name'));

                let password = element.attr('name') == 'password';
                let password_confirmation = element.attr('name') == 'password_confirmation';
                let contact_number = element.attr('name') == 'contact_number';
                let phone_number_for_customers = element.attr('name') == 'phone_number_for_customers';

                if (contact_number) {
                    error.appendTo(element.siblings(".error-container"));
                } else if (phone_number_for_customers) {
                    error.appendTo(element.siblings(".error-container"));
                } else if (password) {
                    error.appendTo(element.parent().siblings(".error-container-password"));
                } else if (password_confirmation) {
                    error.appendTo(element.parent().siblings(".error-container-confirm"));
                }
                else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function (form) {

                $.ajax({
                    url: $(form).attr('action'),
                    method: "POST",
                    data: $(form).serialize(),
                    beforeSend: function () {

                        $("button[type='submit']").text("Submitting...")

                    },
                    success: function (response) {

                        alert("Form submitted successfully")

                        $("#multiForm")[0].reset()

                    },
                    error: function () {

                        alert("Something went wrong")

                    },
                    complete: function () {

                        $("button[type='submit']").text("Submit")

                    }

                })

                return false

            }

        })
    }
}));

Alpine.plugin(intersect)

window.Alpine = Alpine;
